<div id="tour-legend" class="pro-legend">
  <div>
    <div class="pro-legend__title">Legend</div>
    <div class="pro-legend__item">
      <div class="legend-color" [style.color]="institutionColor + ' !important'"></div>
      <div class="legend-text">
        {{ institution().name }}
      </div>
    </div>
    @if (peerName()) {
    <div class="pro-legend__item">
      <div class="legend-color" [style.color]="peerColor + ' !important'"></div>
      <div class="legend-text">
        {{ peerName() }}
      </div>
    </div>
    }
    @if (rate()) {
    <div class="pro-legend__item">
      <div class="legend-color" [style.color]="rateColor + ' !important'"></div>
      <div class="legend-text" [style.color]="institutionColor + ' !important'">
        {{ rate()?.rateName }}
      </div>
    </div>
    }
  </div>
  <div class="bal__numbers bal__numbers--legend">
    <div class="pro-legend__title">{{ roomName() }} Scores</div>
    <div class="bal__numbers bal__numbers--legend">
      <div class="bal__num-wrap" style="color: rgb(28, 69, 153);">
        <div class="bal__num bal__num--{{ institutionValue() }}" [innerHtml]="institutionValue() ?? '&#8212;'"></div>
        <div class="tooltip">{{ institution().name }}<br /><br />{{ metric().description1 }}</div>
      </div>
      <div class="bal__num-wrap" style="color: rgb(239, 118, 122);">
        <div class="bal__num bal__num--{{ peerValue() }}" [innerHtml]="peerValue() ?? '&#8212;'"></div>
        <div class="tooltip">{{ peerName() }}<br /><br />{{ metric().description1 }}</div>
      </div>
    </div>
  </div>
</div>
